import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class ManagerModification extends ShadowDOMElement {
	static className = "ManagerModification";
	
	static properties = {
		id: { type: String },
		validationRequired: { 
			type: Boolean, 
			attribute: "validation-required",
			converter: {
				fromAttribute: (value) => value === "false" ? false : true,
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		validationMessage: {
			type: String,
			attribute: "validation-message"
		},
		checkboxValidationRequired: {
			type: Boolean,
			attribute: "checkbox-validation-required",
			converter: {
				fromAttribute: (value) => value === "false" ? false : true,
				toAttribute: (value) => (value ? "true" : "false"),
			}
		},
		orInclusiveValidation: {
			type: Boolean,
			attribute: "or-inclusive-validation",
			converter: {
				fromAttribute: (value) => value === "false" ? false : true,
				toAttribute: (value) => (value ? "true" : "false"),
			}
		}
	};

	constructor() {
		super();
		this.id = "manager-modification";
		this.validationRequired = true;
		this.validationMessage = "Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale.";
		this.checkboxValidationRequired = true;
		this.orInclusiveValidation = false;
	}

	render() {
		// When OR-inclusive validation is active, individual manager-list checkbox
		// validation is automatically disabled (the global OR check is sufficient)
		const effectiveCheckboxValidation = this.orInclusiveValidation ? false : this.checkboxValidationRequired;

		return html`
			<div id="${this.id || ''}">
				<manager-list
					id="ManagerListGerant"
					title="Dirigeant / Gerant"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
					checkbox-validation-required="${effectiveCheckboxValidation}"
				></manager-list>

				<manager-list
					id="ManagerListPresident"
					title="Dirigeant / Président"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
					checkbox-validation-required="${effectiveCheckboxValidation}"
				></manager-list>

				<manager-list
					id="ManagerListPresidentGeneralDirector"
					title="Dirigeant / Président directeur général"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
					checkbox-validation-required="${effectiveCheckboxValidation}"
				></manager-list>

				<manager-list
					id="ManagerListGeneralDirector"
					title="Dirigeant / Directeur général"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
					checkbox-validation-required="${effectiveCheckboxValidation}"
				></manager-list>

				<manager-list
					id="ManagerListDelegate"
					title="Dirigeant / Directeur général délégué"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
					checkbox-validation-required="${effectiveCheckboxValidation}"
				></manager-list>

				<manager-list
					id="ManagerBind"
					title="Dirigeant / Personne ayant le pouvoir d'engager la société"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
					checkbox-validation-required="${effectiveCheckboxValidation}"
				></manager-list>
			</div>
		`;
	}

	isTransient() {
		return false;
	}

	getValues() {
		return {
			...super.getValues()
		}
	}

	setValues(values) {
		super.setValues(values);
	}

	validate() {
		// Remove previous validation messages from parent component
		this.shadowRoot.querySelectorAll('.validation-error-message').forEach(el => el.remove());

		// If validation is not required, always return true
		if (!this.validationRequired) {
			return true;
		}

		// Get all manager-list components
		const managerComponents = this.shadowRoot.querySelectorAll('manager-list');
		
		// Check if at least one checkbox is marked in any manager-list
		let hasChecked = false;
		
		for (const managerComponent of managerComponents) {
			const checkboxes = managerComponent?.shadowRoot?.querySelectorAll('checkbox-field');
			if (checkboxes) {
				const componentHasChecked = Array.from(checkboxes).some(cb => !!cb.checked);
				if (componentHasChecked) {
					hasChecked = true;
					break;
				}
			}
		}

		// If at least one checkbox is marked across all components, it's valid
		if (hasChecked) {
			return true;
		}

		// If no checkbox is marked, show error
		this.showValidationError();

		return false;
	}

	showValidationError() {
		const errorDiv = document.createElement('div');
		errorDiv.className = 'validation-error-message text-danger d-flex align-items-center mb-3';
		errorDiv.style.paddingLeft = '0px';

		const icon = document.createElement('i');
		icon.className = 'fa-solid fa-circle-exclamation me-2';
		icon.setAttribute('aria-hidden', 'true');

		const text = document.createElement('span');
		text.textContent = this.validationMessage;

		errorDiv.appendChild(icon);
		errorDiv.appendChild(text);

		// Insert the message at the beginning of the main container
		const container = this.shadowRoot.querySelector('div');
		if (container && container.firstChild) {
			container.insertBefore(errorDiv, container.firstChild);
		}
	}
}

customElements.define("manager-modification", ManagerModification);
